<template>
<v-layout row wrap justify-space-around>
  <v-flex xs12>
      <v-card-title class="headline">
          <span v-if="typeSelected">{{typeSelected.name}}</span>
          <span v-else>Todos os produtos</span>
        <v-spacer></v-spacer>
        <template v-if="!typeSelected || !typeSelected.highlight">
            <v-btn color="success" @click="showForm()" v-if="viewType == 1 && !$vuetify.breakpoint.xsOnly">
                Novo Produto
            </v-btn>
        </template>
        <v-btn-toggle v-model="viewType" mandatory>
              <v-btn flat :value="0">
                <v-icon>view_comfy</v-icon>
              </v-btn>
              <v-btn flat :value="1">
                <v-icon>view_list</v-icon>
              </v-btn>
        </v-btn-toggle>
        <template v-if="!typeSelected || !typeSelected.highlight">
        <v-btn icon color="success" large @click="showForm()" v-if="$vuetify.breakpoint.xsOnly">
            <v-icon large>add</v-icon>
        </v-btn>
        </template>
      </v-card-title>
  </v-flex>
  <v-flex xs12>
    <v-layout justify-center wrap>
        <v-flex md6 mb-1>
            <v-text-field
                :label="$t('home.search')"
                solo clearable
                v-model="search"
                hide-details
                @input="searchAction"
                :loading="searching"
                prepend-inner-icon="search"
                type="text"
            ></v-text-field>
            <div class="mt-2">
                <v-chip close v-if="subtype !=''" @input="subtype = ''">{{subtype}}</v-chip>
                <template v-for="(value,index) in filter">
                    <v-chip close v-if="value !==''" @input="filter[index] = '';refresh()"
                    :key="index"
                    >
                        {{$t(`filter.${index}.${value}`)}}
                    </v-chip>
                </template>
            </div>
        </v-flex>
        <v-btn large @click="subtypes = true">
            filtros
        </v-btn>
    </v-layout>
  </v-flex>
  <v-flex>
    <v-slide-y-reverse-transition>
        <sp-products-list v-if="viewType == 0"></sp-products-list>
        <sp-products-table v-else></sp-products-table>
    </v-slide-y-reverse-transition>
  </v-flex>
  <v-dialog v-model="productDialog" max-width="860px"
      persistent scrollable :fullscreen="$vuetify.breakpoint.xsOnly"
  >
      <sp-form-product @close="productDialog=false">
      </sp-form-product>
  </v-dialog>
  <v-dialog v-model="multiproductDialog" max-width="860px"
    persistent scrollable :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <sp-form-multi-products>
    </sp-form-multi-products>
  </v-dialog>
    <v-dialog v-model="subtypes"
      width="400" scrollable
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <sp-filter color="primary" @exit="subtypes = false"></sp-filter>
    </v-dialog>
</v-layout>
</template>

<script>
import SpProductsList from '../components/SpProductsList'
import SpFormProduct from '../components/SpFormProduct'
import SpFormMultiProducts from '../components/SpFormMultiProducts'
import SpProductsTable from '../components/SpProductsTable'
import SpFilter from '@/components/SpFilter'

import {mapGetters} from 'vuex'

export default {
    data(){
        return {
            button:null,
            viewType:0,
            timeout:null,
            searching:false,
            multiproductDialog:false,
            subtypes:false
        }
    },
    components:{
        SpProductsList,
        SpFormProduct,
        SpProductsTable,
        SpFormMultiProducts,
        SpFilter
    },
    watch: {
        multiProducts(v){
            this.multiproductDialog = v.length > 0
        },
        viewType(v){
            localStorage.setItem('viewType',v)
        }
    },
    beforeMount(){
        this.viewType = Number.parseInt(localStorage.getItem('viewType') || 0)
    },
    computed: {
        ...mapGetters([
            'typeSelected',
            'multiProducts',
        ]),
        filter:{
            get(){
                return this.$store.state.filter
            },
            set(value){
                this.$store.commit('SET_FILTER', value)
                this.$store.dispatch('fetchProducts')
            }
        },
        subtype:{
            get(){
                return this.$store.state.subtype
            },
            set(value){
                this.$store.commit('SET_SUBTYPE', value)
                this.$store.dispatch('fetchProducts')
            }
        },
        productDialog:{
            get(){
                return this.$store.state.productDialog
            },
            set(v){
                this.$store.state.productDialog = v
            }
        },
        search:{
            get(){
                return this.$store.state.search
            },
            set(value){
                if(!value)value=''
                return this.$store.state.search = value
            }
        }
    },
    methods:{
      refresh(){
          this.filter = Object.assign({},this.filter)
      },
      searchAction(){
          clearTimeout(this.timeout);
            this.timeout = setTimeout(async ()=> {
                try {
                    if(this.search && this.search.trim().length >= 3 || this.search.trim().length == 0 ){
                        this.searching = true
                        await this.$store.dispatch('fetchProducts')
                        this.searching = false
                    }
                } catch (error) {
                    console.log(error);
                }
            }, 1000);
      },
      showForm(product=null){
            this.$store.commit('FETCH_PRODUCT',product)
            this.$store.commit('TOGGLE_PRODUCT_DIALOG')
        }
    }
}
</script>